var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { colors, fontWeights } from '../../../defaultTheme';
import Small from '../../typography/Small';
import Inline from '../../spacing/Inline';
import Inset from '../../spacing/Inset';
const StyledTag = styled(Inset) `
  border-radius: 500px;
  color: ${({ textColor }) => textColor};
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: inline-flex;
  align-items: center;
  font-weight: ${fontWeights.semiBold};
`;
const IconWrapper = styled.span `
  display: flex;
`;
const Tag = (_a) => {
    var { icon, backgroundColor, content, className, textColor = colors.black } = _a, props = __rest(_a, ["icon", "backgroundColor", "content", "className", "textColor"]);
    return (React.createElement(StyledTag, Object.assign({}, props, { backgroundColor: backgroundColor, textColor: textColor, className: className, vertical: "medium", horizontal: "xsmall" }),
        icon && (React.createElement(IconWrapper, { className: "Tag__icon-wrapper" },
            icon,
            React.createElement(Inline, { size: "small" }))),
        React.createElement(Small, { isInline: true, className: "Tag__content", weight: "semiBold" }, content)));
};
export default Tag;
